var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-d-flex p-ai-center"},[_c('i',{staticClass:"pi pi-credit-card p-mr-2 p-text-gray"}),_vm._v(" "+_vm._s(_vm.payments.length)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }